import AxiosInstance from "services/api";

export const CashVoucherService = {
  getPaginate: async (query) => {
    return await AxiosInstance.get("/private/cash-voucher", { params: query });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/cash-voucher/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/cash-voucher", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/cash-voucher/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/cash-voucher/${id}`);
  },
};
